import {FormInputBorder} from 'module/CustomField/component/FormInputBorder'
import {CF} from "module/CustomField/util/CustomField"
import React from 'react'
import {CustomFieldMembersComponentProps} from 'module/CustomField/type/CFComponentType';
import {AddCFRowButton} from 'module/CustomField/component/button/AddCFRowButton';
import {ClearCFRowsButton} from 'module/CustomField/component/button/ClearCFRowsButton';
import {cssCFLabelSticky, cssCFSubLabelSticky} from 'module/CustomField/style/cssCFLabelStickyStyles'
import {CustomFieldMemberComponent} from 'module/CustomField/component/CustomFieldMemberComponent'
import {filterCFErrors} from 'module/CustomField/util/filterCFErrors'

export const CustomFieldMembersComponent = React.memo(function (props: CustomFieldMembersComponentProps) {
	const {
		model, cfDef, group, pos, disabled, validationResult,
		setCFValue, addCFValue, deleteCFValue, hideArrayButtons, labelDone, labelHidden, inlineLabel,
	} = props
	const isCFNamespace = CF.isCFNamespace(cfDef)
	const v = CF.getValueFrom(cfDef, model, {pos})
	let cfMembers = !Array.isArray(v) ? [v] : v
	const positions = CF.getPositions([cfDef], model)
	const cfMembersLen = positions.length
	let showAddButton = false
	let showCleanButton = false
	let posNext: number | undefined;
	if (isCFNamespace && !hideArrayButtons) {
		if (!disabled && (!cfDef.maxAmount || cfDef.maxAmount > cfMembersLen)) {
			showAddButton = true
			posNext = CF.getNextPos([cfDef], model)
		}
		if (!disabled && cfDef.minAmount < cfMembersLen) {
			showCleanButton = true
		}
	}
	if (!model) return null;
	const arrayButtonVisible = !hideArrayButtons && (showAddButton || showCleanButton)

	return (
		<div
			style={{
				gridRow: `span ${cfDef.rowSpan == null ? 1 : cfDef.rowSpan}`,
				gridColumn: `span ${cfDef.colSpan == null ? 1 : cfDef.colSpan}`,
			}}
			className={'CustomFieldMembersComponent'}
		>
			<FormInputBorder
				label={labelDone || labelHidden ? undefined : cfDef.label}
				cssLabel={group?.heading || group?.mergeAmountButtons ? cssCFSubLabelSticky : cfDef.maxAmount > 1 ? cssCFLabelSticky : undefined}
				afterLabel={arrayButtonVisible && <div>
					{showAddButton && <AddCFRowButton onClick={() => addCFValue?.({cfDefs: [cfDef], pos: posNext})}/>}
					{showCleanButton && <ClearCFRowsButton onClick={() => deleteCFValue?.({cfDefs: [cfDef], clearNullValues: true})}/>}
				</div>}
				required={cfDef.required}
				inline={inlineLabel}
				validationResult={filterCFErrors(validationResult, cfDef, pos)}
			>
				{cfMembers.map((cfMember, i) =>
					<CustomFieldMemberComponent {...props} key={i} cfMember={cfMember} isCFNamespace={isCFNamespace}/>,
				)}
			</FormInputBorder>
		</div>
	)
})